module.exports = __webpack_public_path__ + "static/media/newdetail1.8db657bb.jpg";